// Replace with your request types
export const GET_THEME_REQUEST = "GET_THEME_REQUEST";
export const GET_THEME_RECEIVE = "GET_THEME_RECEIVE";
export const GET_THEME = "GET_THEME";
